import {Injectable} from "@angular/core";
import {CountryModel} from "../models";
import {countryConfig} from "../configs";

@Injectable({
	providedIn: 'root'
})
export class CountryService {

	public getCountries(): CountryModel[] {
		return this.getEuropeanCountries();
	}

	private getEuropeanCountries(): CountryModel[] {
		return Object.values(countryConfig.europe);
	}
}